import RagContentDisplay from "./RagContentDisplay";
import styles from "./MessagesDisplayer.module.css";
import ChatbotLoadingMessage from "./ChatbotLoadingMessage";
import useAffichage from "../administration/manageTechnical/Affichage/useAffichage";


function SearchFoundDocumentComponent({ text_to_show }) {
    return <div className="flex items-start gap-5 pb-3 w-full">
        <div className="w-6 h-6 pt-3">
            <img
                src="/chatbot-black.svg"
                alt="user" className="w-full flex-shrink-0" />
        </div>

        <div
            className={`${styles.message} bg-figmaColors-chatbotAssistantMessage fadeIn p-4 font-light rounded-r-xl rounded-bl-xl shadow-lg transform duration-500 w-full`}>
            {text_to_show}
        </div>
    </div>
}

function VCaddS(s: string, n: number) {
    return n > 1 ? s + "s" : s  
}

export default function SearchModeDisplayer({ searchResponse, isWaitingForResponse, statusMessage, MessageSearch, companyUUID }) {
    const found_files_text = <>Nous avons trouvé <b className="font-bold">{searchResponse?.rag?.length} {VCaddS("extrait", searchResponse?.rag?.length)}</b> en relation avec votre demande.</>
    const [{percentages}] = useAffichage();
    return (
        <div className="relative text-base text-black py-12 lg:py-8 w-full max-w-screen-lg mx-auto px-4 space-y-4 ">
            {/* Si isLoading est vrai, affiche l'icône de chargement */}
            {statusMessage != null || isWaitingForResponse ? <ChatbotLoadingMessage statusMessage={statusMessage} addTopPadding={false} /> : (
                // Si isLoading est faux, affiche le contenu de la réponse
                <>
                    {/* Affiche le nombre de fichiers, ou 0 si aucun résultat */}
                    {searchResponse?.rag?.length > 0
                        ? <SearchFoundDocumentComponent text_to_show={found_files_text} />
                        : <SearchFoundDocumentComponent text_to_show={MessageSearch} />}
                    {/* Affiche chaque résultat sous forme de carte */}
                    {searchResponse?.rag?.map((rag, key) => (<div className="flex items-start gap-5 pb-3 w-full ">
                        <div className="w-6 h-6 pt-3">

                        </div>
                        <div
                            key={key}

                            className="bg-white font-light rounded-r-xl rounded-bl-xl shadow-lg transform duration-500 w-full overflow-auto fadeInBottom"
                        >
                            <RagContentDisplay rag={rag} showPercentages={percentages} companyUUID={companyUUID}/>
                        </div></div>
                    ))}
                </>
            )}
        </div>
    );
}
